import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import SEOHead from '../components/SEO/SEOHead';

const TermsOfServicePage: React.FC = () => (
  <Box sx={{ maxWidth: 800, mx: 'auto' }}>
    <SEOHead
      title="Terms of Service"
      description="Hooliah's terms of service — rules, content licensing, and user responsibilities."
      canonicalUrl="https://hooliah.com/terms-of-service"
    />

    <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 1 }}>Terms of Service</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Last updated: June 2025</Typography>

    <Typography variant="body1" paragraph>
      Welcome to Hooliah. By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our platform.
    </Typography>

    <Divider sx={{ my: 3 }} />

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>1. Acceptable Use</Typography>
    <Typography variant="body1" paragraph>
      You agree to use Hooliah only for lawful purposes. You must not upload content that is abusive, harassing, sexually explicit, hateful, or violates any applicable law. Content must be fashion-related and appropriate for a teen and young-adult audience. We reserve the right to remove content and suspend accounts that violate these guidelines.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>2. User-Generated Content & Licensing</Typography>
    <Typography variant="body1" paragraph>
      You retain ownership of content you upload to Hooliah. By uploading content, you grant Hooliah a non-exclusive, worldwide, royalty-free license to use, display, reproduce, and distribute your content in connection with operating and promoting the platform. You represent that you have the right to grant this license.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>3. Intellectual Property</Typography>
    <Typography variant="body1" paragraph>
      The Hooliah platform, including its design, features, and technology, is owned by Hooliah and protected by intellectual property laws. You may not copy, modify, or distribute any part of our platform without written permission.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>4. Account Termination</Typography>
    <Typography variant="body1" paragraph>
      We may suspend or terminate your account at any time if you violate these Terms, engage in abusive behavior, or if your content is repeatedly flagged or rejected by our moderation system. You may delete your account at any time through your account settings.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>5. Limitation of Liability</Typography>
    <Typography variant="body1" paragraph>
      Hooliah is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the platform. Our total liability shall not exceed the amount you paid to us in the past 12 months (if any).
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>6. Dispute Resolution</Typography>
    <Typography variant="body1" paragraph>
      Any disputes arising from these Terms shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. These Terms are governed by the laws of the State of California, United States.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>7. Contact</Typography>
    <Typography variant="body1" paragraph>
      For questions about these Terms, contact us at legal@hooliah.com.
    </Typography>
  </Box>
);

export default TermsOfServicePage;
